<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.truck.list.label.title')}}</h4></h4>
                    </div>
                    
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{$t('string.msg.truck.search.description')}}
                </p>

                <form>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.trucktrailer.register.manufacturs.label')}}
                            </label>
                            <select id="manufacturer" v-model="filters.manufacturer" class="form-control">
                                <option :value="-1">{{$t('string.msg.select.selector.item')}}</option>
                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{ $t('string.msg.trucktrailer.register.plate.label') }}
                            </label>
                                <input type="text" onkeyup="this.value = this.value.toUpperCase();" v-model="filters.plate" class="form-control" v-mask="['AAA #X##']" :placeholder="$t('string.msg.truck.register.placeholder.plate')">
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </form>
                <div id="vue-table">
                    <div class="table-responsive">
                        <table class="table table-centered table-hover mb-0" id="datatable">
                            <thead>
                                <tr>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.manufacture')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.model')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.year')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.Placa')}}</th>
                                    <th class="border-top-0">{{$t('string.msg.truck.table.header.group')}}</th>
                                </tr>
                            </thead>
                            <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                                 <tr v-if="item && item.status == 'ACTIVE'">
                                    <td>
                                        <span>
                                            {{item.manufacturer.name}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.model && item.model.name">
                                            {{item.model.name}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{item.year}}
                                        </span>
                                    </td>
                                    <td>
                                        <span>   
                                            {{item.plate}}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.truckTrailers.length > 0">   
                                            {{$t('string.msg.truck.table.text.yes')}}
                                        </span>
                                        <span v-else>
                                            {{$t('string.msg.truck.table.text.no')}}
                                        </span>
                                    </td>
                             
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
          <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListTruck';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();

export default {
  name: 'ListTruck',
  props: ["valuekey"],

  components: {
    Spinner,
    Toast
  },
 
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        certifies:[],
        manufacturers: [],
        filters: {
            manufacturer: null,
            company: null,
            plate:null,
            status: 'ACTIVE',
            vehicleTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK",
                "TRUCK_MECHANICAL_HORSE_SIMPLE",
                "TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO",
                "TRUCK_DOUBLE_TRAIN","TRUCK_RODOTREM"]
        }
      }
  },
  methods: Controller.methods,
  created() {
      let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
    Controller.init(this);
    this.filters.company= this.$session.get('user').companyUser.company._id;
    this.filter();
  }

}
</script>

<style>
</style>
